angular.module('pitch.media')
.controller('PitchMediaListCtrl', function($scope, TrackInfoModal, ReportTrackModal, UserTerritory, $q, Chart, config) {
    "use strict";

    //defauls to logged in user mp3
    $scope.context = $scope.$parent.context || {name: 'user'};
    $scope.auditionFormat = $scope.$parent.auditionFormat || "mp3";

    UserTerritory.get(function(r) {
        $scope.userTerritory = r;
    });

    $scope.info = function(track) {
        TrackInfoModal.open({}, {
            track: track
        });
    };

    $scope.pluck = function(collection, separator) {
        return collection.map(function(elem) {
            return elem.name;
        }).join(separator);
    };

    $scope.getChartData = function(track) {
        var defer = $q.defer();

        Chart.query({
            trackId: track.id
        }, function(r) {
            defer.resolve({
                charts: r
            });
        });

        return defer.promise;
    };

    $scope.reportTrack = function(track) {
        ReportTrackModal.open({}, {
            track: track.id
        });
    };

    $scope.editTrack = function(track) {
        var uri = config.baseUrladmin + '/trackadmin/edit/' + track.id;
        window.open(uri, '_blank');
    };
});



// WEBPACK FOOTER //
// ./src/MediaClientBundle/Resources/js/angular/controllers/PitchMediaListCtrl.js